// extracted by mini-css-extract-plugin
module.exports = {"InputError":"style_InputError__36JSj","wrapper":"style_wrapper__1OwL2","error":"style_error__21ISC"};